import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import ViewWork from '@Components/ViewWork'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { useParams } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import SongwriterWorkHeader from '@Components/ViewWork/Headers/SongwriterWorkHeader'
import { PARAM } from '@App/navigation/param'

const ViewWorkSongwriterScene = () => {
    const { publicViewWorkStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()

    useEffect(() => {
        analyticsSendPage('view_work_songwriter')
        const workId = params.workId
        if (!workId || isNaN(Number(workId))) {
            throw new Error('Unable to parse work ID ' + workId)
        }
        publicViewWorkStore.getWorkCatalogById(workId).then()
        return () => {
            publicViewWorkStore.resetViewWorkPublic()
        }
    }, [])

    const work = publicViewWorkStore.viewWorkPublic
    return (
        <>
            <title>View Work</title>

            <div className="view-work-scene">
                {work ? (
                    <>
                        <SongwriterWorkHeader work={work} />
                        <ViewWork viewWork={work} showMatchedRecordings workType="work" />
                    </>
                ) : (
                    <PointPreloader />
                )}
            </div>
        </>
    )
}
export default observer(ViewWorkSongwriterScene)
